

















































































import { Component, Prop, Vue } from "vue-property-decorator";
import TaskList from "../components/TaskList.vue";
import TaskListItem from "../components/TaskListItem.vue";
import Task, { TaskParam } from "../models/task";

import { client } from "@/api/request";
import TaskApi from "../../api/task-api";
import TaskService from "../../usecases/task-service";
import Subtask from "@/api/project/subtask";
import SubtaskApi from "../../../api/project/subtask-api";
import AppHeader from "../../../views/AppHeader.vue";
import StaffApi from "@/api/staff-api";
import TaskModal from "@/components/task/TaskModal.vue";
import _ from "lodash";
import { getServiceSettingTask } from "@/api/service-api.ts";
import ProjectManagerApi from "@/api/gateways/project-manager-api";
import ProjectWorkerApi from "@/api/gateways/project-worker-api";
import ProjectWorker from "@/entities/project-worker";
import ProjectManager from "@/entities/project-manager";
import { getAllClientStaffs } from "@/api/client-api";

const service = new TaskService(new TaskApi(client));
interface InternalUser {
  text: string;
  value: string | number;
  userId?: string | number;
}

interface ExternalUser {
  text: string;
  value: string | number;
  userId?: string | number;
}

interface UserOption {
  id: string | number;
  name: string | number;
}

@Component({
  components: {
    AppHeader,
    TaskList,
    TaskListItem,
    TaskModal
  }
})
export default class UserTaskList extends Vue {
  @Prop({ default: false }) readonly listTasksScreen?: boolean;

  tasks: Task[] = [];
  task: Task = {} as Task;
  dateDefault = "";
  timeDefault = "";
  taskOpen: boolean = false;
  hiddenDoneTasks = true;
  orderBy = "duedate";
  externalUser: string | number = "";
  internalUser: string | number = "";
  internalUsers: InternalUser[] = [] as InternalUser[];
  externalUsers: ExternalUser[] = [] as ExternalUser[];
  users: UserOption[] = [] as UserOption[];
  id: string | number = "";
  isEditTask: boolean = false;
  editable: boolean = false;
  message: string = "";
  isLoading: boolean = false;
  orderOptions = [
    {
      text: "期限順",
      value: "duedate"
    },
    {
      text: "作成順",
      value: ""
    },
    {
      text: "現場順",
      value: "project"
    }
  ];

  /**
   * 完了・未完了を切り替える
   */
  async toggle(task: Task, done: boolean) {
    let userIds: string[] | number[] = [];
    if (task.users) {
      userIds = task.users.map(item => item.id) as string[];
    }

    const subtask = new Subtask(
      Number(task.id),
      task.name,
      done,
      task.dueDate,
      userIds as string[],
      task.projectId as string
    );
    const api = new SubtaskApi(client);
    await api.save(subtask);
    // 先にタスク取得が動いてしまうので遅らせる
    setTimeout(() => {
      this.loadTasks();
    }, 100);
  }

  toggleDisplayMode() {
    this.message = "";
    this.hiddenDoneTasks = !this.hiddenDoneTasks;
    this.loadTasks();
  }

  get btnLabel() {
    if (this.hiddenDoneTasks) {
      return "完了したタスクを表示する";
    }
    return "完了したタスクを非表示にする";
  }

  protected async mounted() {
    this.isLoading = true;
    const res = await getServiceSettingTask();
    this.editable = !!res.editable;
    await this.loadIntenalUser();
    this.isLoading = false;
  }

  private async loadIntenalUser(loadTask = true, reloadUser = true) {
    this.editable = this.$store.state.user.hasRole || this.editable;
    const internalUsers = await new StaffApi(client).getAll({
      family: 1,
      hasRole: this.$store.state.user.hasRole
    });
    const externalUsers = await new StaffApi(client).getAll({ family: 0 });
    if (this.editable) {
      this.internalUsers = [
        {
          text: "全て",
          value: ""
        }
      ];
      this.externalUsers = [
        {
          text: "全て",
          value: ""
        }
      ];
    }
    if (reloadUser) this.externalUser = "";
    const user = this.$store.state.user;
    this.users = [
      {
        id: user.staffId,
        name: user.name
      }
    ];

    externalUsers.forEach(item => {
      this.externalUsers.push({
        text: item.name,
        value: item.id,
        userId: item.userId
      });
    });

    internalUsers.forEach(item => {
      this.users.push({
        id: item.id,
        name: item.name
      });
      if (this.$store.state.user.userId == item.userId && reloadUser) {
        this.internalUser = item.id;
      }
      this.internalUsers.push({
        text: item.name,
        value: item.id,
        userId: item.userId
      });
    });

    if (this.editable) {
      this.internalUsers.push({
        text: "",
        value: "-1"
      });
      this.externalUsers.push({
        text: "",
        value: "-1"
      });
    }

    if (loadTask) await this.loadTasks();
  }

  private async loadTasks() {
    const userIds: string[] | number[] = [] as string[];
    const staffIds: string[] | number[] = [] as string[];
    const userStaffIds: string[] | number[] = [] as string[];

    this.internalUsers.forEach(item => {
      if (this.internalUser) {
        if (item.value && this.internalUser == item.value) {
          if (item.userId) userIds.push(item.userId as string);
          else if (this.internalUser == -1) userIds.push("-1");
          userStaffIds.push(item.value as string);
        }

        return;
      }

      if (this.$store.state.user.hasRole) {
        if (item.userId) userIds.push(item.userId as string);
        if (item.value && item.value != -1)
          userStaffIds.push(item.value as string);
      } else if (this.$store.state.user.userId == item.userId) {
        userIds.push(item.userId as string);
        userStaffIds.push(item.value as string);
      }
    });

    this.externalUsers.forEach(item => {
      if (this.externalUser) {
        if (item.value && this.externalUser == item.value) {
          staffIds.push(item.value as string);
        }

        return;
      }

      if (item.value && item.value != -1 && this.$store.state.user.hasRole) {
        staffIds.push(item.value as string);
      } else if (this.$store.state.user.userId == item.userId) {
        staffIds.push(item.value as string);
        userStaffIds.push(item.value as string);
        userIds.push(item.userId as string);
      }
    });

    this.message = "";
    this.tasks = (await service.search(
      new Date(),
      this.hiddenDoneTasks,
      this.orderBy,
      userIds,
      staffIds,
      userStaffIds
    )).map(t => ({
      ...t,
      dueDateVariant: t.overdue ? "danger" : ""
    }));

    if (!this.tasks.length) {
      this.message = "タスクが存在しません";
    }
  }

  async handleOpenModalTask(task = {} as Task) {
    this.taskOpen = true;
    this.isLoading = true;
    if (Object.keys(task).length) {
      this.id = task.id;
      this.task = _.clone(task);
      this.task.project = ({
        id: this.task.projectId,
        name: this.task.project
      } as unknown) as string;
      this.isEditTask = true;
      this.timeDefault = this.task.time as string;
      if (((this.task.project as unknown) as { id: number }).id)
        await this.loadProjectMembers(this.task.projectId as number);
    } else {
      this.isEditTask = false;
      this.task = ({
        canEditProject: true,
        canEditName: true
      } as unknown) as Task;
      this.id = "";
      this.timeDefault = "";
    }
    this.isLoading = false;
  }

  async loadProjectMembers(id: number) {
    this.users = [];
    const pm = new ProjectManagerApi(this.$store.getters.api, id);
    const pw = new ProjectWorkerApi(this.$store.getters.api, id);
    const resPm = await pm.assigned();
    const resPw = await pw.assigned();
    const clientStaffList = ((await getAllClientStaffs(
      (id as unknown) as string
    )) as unknown) as {
      staffId: string | number;
      name: string;
      isHiddenInfo: boolean;
    }[];
    resPm.forEach((item: ProjectManager) => {
      if (!item.isHiddenInfo) {
        this.users.push({
          id: item.id,
          name: item.name
        });
      }
    });

    resPw.forEach((item: ProjectWorker) => {
      if (!item.isHiddenInfo) {
        this.users.push({
          id: item.id,
          name: item.name
        });
      }
    });

    clientStaffList.forEach(item => {
      if (!item.isHiddenInfo) {
        this.users.push({
          id: item.staffId,
          name: item.name
        });
      }
    });
  }

  async handleSetTask(data: TaskParam) {
    const api = new SubtaskApi(client);
    const dueDate = data.date
      ? data.time
        ? `${data.date} ${data.time}`
        : data.date
      : "";
    const userIds = data.users
      ? data.users.map((item: UserOption) => item.id)
      : [];
    const projectId = data.project
      ? ((data.project as unknown) as { id: string }).id
      : "";
    const subtask = new Subtask(
      this.id || "",
      data.name,
      false,
      dueDate,
      userIds as string[],
      projectId as string
    );

    await api.save(subtask);
    await this.loadIntenalUser();
    this.task = {} as Task;
    this.taskOpen = false;
    this.isEditTask = false;
  }

  async handleDeleteTask() {
    if (!confirm("本当にタスクを削除しますか？")) return;

    const api = new SubtaskApi(client);
    await api.delete(this.id);
    await this.loadTasks();
    this.taskOpen = false;
  }

  async handleChangeUsers(users: UserOption[] | boolean) {
    if (users == true) {
      this.isLoading = true;
      await this.loadIntenalUser(false, false);
      this.isLoading = false;
    } else {
      this.users = users as UserOption[];
    }
  }

  handleChangeProject(project: string) {
    if (project.length) {
      return (this.task.project = project);
    }

    this.task.project = ([] as unknown) as string;
    this.users = [];
  }
}
